<template>
<span>
    <BI-details></BI-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import BIDetails from '@/components/moduls/BIDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'hoghugh',
    components:{
        BIDetails,
        PageFooter
    }

    
};
</script>


